import { handleApiCalls } from './axiosInstance';
import BaseAPI from './baseAPI';

class GasPricesAPI extends BaseAPI {
  constructor() {
    super({ suffix: 'gas-prices' });
  }

  /**
   * Fetches the current gas price for a ZIP code.
   *
   * @param {string} zip ZIP code used to look up the gas price
   * @returns {Promise<{price: number}>} Gas price data
   */
  async fetchGasPrices(zip) {
    const response = await handleApiCalls('get', `${this.baseUrl}/${zip}`);
    return response.data;
  }
}

export default GasPricesAPI;
